<script lang="ts" module>
  import ToastComponent from './Toast.svelte';
  import type { ClassValue } from 'svelte/elements';

  export type Toast = {
    id: symbol;
    message: string;
    // This is a safelist for Tailwind:
    // alert-success alert-error alert-warning alert-info
    type: 'success' | 'error' | 'warning' | 'info';
    duration: number;
    class?: ClassValue;
  };

  let toasts = $state<Toast[]>([]);

  export function addToast(toast: Omit<Toast, 'id' | 'duration'> & { duration?: number }) {
    toasts.unshift({
      id: Symbol(),
      duration: toast.duration ?? 5_000,
      ...toast,
    });
  }

  export function removeToast(id: symbol) {
    toasts = toasts.filter((toast) => toast.id !== id);
  }
</script>

<div class="toast z-1000">
  {#each toasts as toast (toast.id)}
    <ToastComponent {toast} onRemove={() => removeToast(toast.id)} />
  {/each}
</div>
